import { AxiosResponse } from 'axios'

import AbstractHttpService from '@services/abstractHttpService'
import urls from '@const/urls'

import { IUserFilter, IUserFilterSave } from './types'

class UserFiltersService extends AbstractHttpService {
  private readonly url = urls.userFilters

  async getUserFilters (): Promise<AxiosResponse<IUserFilter[]>> {
    return await this._http.get(this.url.list)
  }

  async postUserFilter (data: IUserFilterSave): Promise<AxiosResponse<IUserFilter>> {
    return await this._http.post(this.url.list, data)
  }

  async putUserFilter (filterOguid: string, data: IUserFilterSave): Promise<AxiosResponse<IUserFilter>> {
    const url = this.url.single.replace('{{ filterOguid }}', filterOguid)

    return await this._http.put(url, data)
  }

  async deleteUserFilter (filterOguid: string): Promise<AxiosResponse> {
    const url = this.url.single.replace('{{ filterOguid }}', filterOguid)

    return await this._http.delete(url)
  }
}

export default new UserFiltersService()
